export const name = 'earn';

export const Earn = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    color="#161619"
  >
    <path
      d="M20.5 7.81812L13.2955 15.0227L8.97727 10.7045L2.5 17.1818"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M15.3181 6.81812H21.4999V12.9999"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
